export enum ChartColors {
  Home = '#fcc250',
  OnSite = '#00838f',
  NoResponse = '#dcf0f2',
  NotWorking = '#EF6E6C',
  Holiday = '#F15050',
  Event = '#8F6593',
  HighlightTeam = '#f571c7',
  Available = '#00838f',
  Reserved = '#dcf0f1',
  InUse = '#EF6E6C',
  Booked = '#fcc250',
  Item = '#8F6593',
  Filters = '#00838f',
  ChartBackground = '#dcf0f2',
  AssetMapLabel = '#000000',
  PlotOpacity = '0.3',
}

export enum ChartLabels {
  Home = 'Home',
  OnSite = 'On Site',
  NoResponse = 'No Response',
  NotWorking = 'Not Working',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Available = 'Available',
  Reserved = 'Reserved',
  InUse = 'In Use',
  Booked = 'Booked',
  Item = 'Item',
  DefaultView = 'Default View',
  ConnectLabel = 'Connect Day',
  ConnectIcon = 'fa-duotone fa-solid fa-calendar-users',
  ConnectView = 'Full',
}
